import { get, IHttpRequestConfig, put } from "@/browser";
import { extractDataFromResponse } from "@/core/api";
import { compose } from "@/core/url";

import { IPersonalInvitation, IRegisterPersonalInvitationDto, personalInvitationType } from "./types";

const API = {
  get: "/api/public/personal-invitations/{invitationId}",
  register: "/api/public/personal-invitations/{invitationId}/register",
};

export interface IFetchConsultantInvitationParams {
  invitationId: number;
  token: string;
}

export const fetchPersonalInvitation = (params: IFetchConsultantInvitationParams, options?: IHttpRequestConfig) => {
  const { invitationId, ...search } = params;
  const url = compose(API.get, { invitationId }, search);
  return get<IPersonalInvitation>(url, options).then(extractDataFromResponse).then(personalInvitationType);
};

export interface IRegisterConsultantInvitationParams {
  invitationId: number;
}

export const registerPersonalInvitation = (
  params: IRegisterConsultantInvitationParams,
  data: IRegisterPersonalInvitationDto,
  options?: IHttpRequestConfig,
) => {
  const url = compose(API.register, params);
  return put<boolean>(url, data, options).then(extractDataFromResponse);
};
